/**
 * @flow
 * @relayHash ab270636609c349d6312805239b86627
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InfoStringDeleteInput = {
  id: string,
  clientMutationId?: ?string,
};
export type InfoStringDeleteMutationVariables = {|
  input: InfoStringDeleteInput
|};
export type InfoStringDeleteMutationResponse = {|
  +InfoStringDelete: ?{|
    +error: ?string
  |}
|};
export type InfoStringDeleteMutation = {|
  variables: InfoStringDeleteMutationVariables,
  response: InfoStringDeleteMutationResponse,
|};
*/


/*
mutation InfoStringDeleteMutation(
  $input: InfoStringDeleteInput!
) {
  InfoStringDelete(input: $input) {
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "InfoStringDeleteInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "InfoStringDelete",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "InfoStringDeleteInput!"
      }
    ],
    "concreteType": "InfoStringDeletePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "InfoStringDeleteMutation",
  "id": null,
  "text": "mutation InfoStringDeleteMutation(\n  $input: InfoStringDeleteInput!\n) {\n  InfoStringDelete(input: $input) {\n    error\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "InfoStringDeleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "InfoStringDeleteMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f81ef095692e2ac0f2885a413764d51';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/InfoStringDeleteMutation.graphql.js